<template>
  <div>
    <div class="os-tabs-w os-tab" style="margin: -5px">
      <ul class="nav nav-tabs upper centered">
        <li class="nav-item">
          <a class="nav-link active">
            <i class="fal fa-sitemap"></i>
            <span>Related Products</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="ae-list-w mt-2">
      <MiniLoader v-if="loadingRelatives" class="mt-5" />
      <div class="ae-list" v-else>
        <div
          class="ae-item"
          v-for="product in relatives"
          @click="onClick(product)"
        >
          <div
            class="aei-image"
            v-if="product.preview && product.preview != null"
          >
            <div class="user-avatar-w">
              <img alt="" :src="product.preview" />
            </div>
          </div>
          <div class="aei-content">
            <h6 class="aei-title">{{ productDisplayName(product) }}</h6>
            <div class="aei-sub-title">
              {{ product.item_identifier || "--" }}
            </div>
            <div class="aei-sub-title">
              {{ product.brand }} - {{ product.category_name || "--" }}
            </div>
            <div v-if="type == 'photodesk'">
              <div
                v-if="product.shoot_count > 0"
                class="aei-sub-title text-success"
              >
                Images Available
              </div>
              <div v-else class="aei-sub-title text-danger">
                No Images Available
              </div>
            </div>
            <div v-if="type == 'copydesk'">
              <div
                v-if="product.id_copydesk_product"
                class="aei-sub-title text-success"
              >
                Copy Available
              </div>
              <div v-else class="aei-sub-title text-danger">
                No Copy Available
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MiniLoader from '@/components/common/MiniLoader'
import Product from '@/mixins/product'
import CommonFunctions from '@/mixins/common-functions.js'

export default {
  props: ['selectedProduct', 'type', 'photodeskRelatives'],
  components: { MiniLoader },
  mixins: [Product, CommonFunctions],
  data () {
    return {
      loadingRelatives: false,
      relatives: []
    }
  },
  mounted () {
    if (this.photodeskRelatives) {
      this.relatives = this.photodeskRelatives
    } else {
      this.getRelatedProducts()
    }
  },
  methods: {
    getRelatedProducts () {
      var self = this
      const url = '/copydesk/product/relatives'

      let data = {
        id_product: self.selectedProduct.id_product
      }
      this.loadingRelatives = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.relatives = response.data.relatives
          self.loadingRelatives = false
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingRelatives = false
        })
    },
    getCopy: function (product) {
      var context = {
        content: product,
        contentType: 'copy',
        show: true
      }
      this.$store.dispatch('updateModal', context)
    },
    onClick (data) {
      if (this.type === 'copydesk') {
        this.getCopy(data)
      } else {
        this.$emit('clickInterface', data.id_product)
      }
    }
  },
  watch: {
    selectedProduct (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getRelatedProducts()
      }
    }
  }
}
</script>

<style>
.btn-xs {
  padding: 0.1rem 0.5rem;
  font-size: 0.3rem;
}
.full-width {
  width: 100%;
}
.side-section .side-section-content {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px 0px;
}

.property-side-features .feature {
  padding: 10px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  font-size: 0.72rem;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 1px;
}

.property-side-features .feature i,
.property-side-features .feature span,
.property-side-features .feature strong {
  display: inline-block;
  vertical-align: middle;
}

.property-side-features .feature span {
  color: rgba(0, 0, 0, 0.6);
}

.property-side-features .feature strong {
  margin-right: 3px;
  color: #111;
}

.property-side-features .feature i {
  color: #047bf8;
  font-size: 15px;
  margin-right: 20px;
}

.property-side-features .feature:last-child {
  border-bottom: none;
}
.user-name {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.user-title {
  margin-bottom: 4px;
}
.user-role {
  font-size: 0.63rem;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.4);
  margin-bottom: 10px;
}
.padded {
  padding: 0.5rem 2rem;
}
.dispatch-location {
  text-align: left;
  display: inline-block;
}
</style>
